export default __webpack_public_path__ + "static/media/PEC.d271f7fe.jpg";